function clickyEvent(...args) {
  const { clicky } = global;
  if (clicky && typeof clicky.log === 'function') {
    clicky.log(...args);
  }
}

export function event(ev) {
  if (!__CLIENT__) {
    return;
  }

  if (__DEV__) {
    console.log('EVENT:', ev);
  }

  const { path, title } = ev;
  clickyEvent(`#${path}`, title);
}

const DELAYED = new Map();

export function eventDelayed(key, ev, delay = 1000) {
  if (DELAYED.has(key)) {
    try {
      clearTimeout(DELAYED.get(key));
    } catch (err) {
      if (__DEV__) {
        console.error(err);
      }
    }
  }
  const timer = setTimeout(() => event(ev), delay);
  DELAYED.set(key, timer);
}
